module.exports = __webpack_public_path__ + "img/首页_05-2.d6e11223.jpg";